export type InfluenceHeaderProps = {
  title: string;
  subtitle: string;
};

export default function InfluenceHeader({ title, subtitle }: InfluenceHeaderProps) {
  return (
    <div className="mb-10 animate-fade-in-down text-center">
      <h1 className="mb-2.5 bg-gradient-to-br from-[#667eea] to-[#764ba2] bg-clip-text text-3xl font-bold text-transparent">
        {title}
      </h1>
      <p className="text-base text-[#8b92a8]">{subtitle}</p>
    </div>
  );
}
